import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from '../theme/ThemeContext';
import chatStore from '../stores/chatStore';

const EmptyState = observer(() => {
    const { theme } = useTheme();
    return (
        <div
            className="flex h-full flex-col items-center justify-center px-6 text-center"
            onClick={() => {
                if (!chatStore.sidebarCollapsed && !chatStore.sidebarPinned) {
                    chatStore.setSidebarCollapsed(true);
                }
            }}
        >
            <div
                className={`mb-4 flex h-14 w-14 items-center justify-center rounded-2xl text-2xl ${
                    theme === 'dark' ? 'bg-white/10' : 'bg-black/5'
                }`}
            >
                ✦
            </div>
            <h2 className="text-xl font-semibold">{chatStore.providerLabel}</h2>
            <p className={`mt-2 max-w-md text-sm ${theme === 'dark' ? 'text-white/60' : 'text-black/55'}`}>
                {chatStore.mode === 'audio'
                    ? 'Выберите модель озвучки или расшифровки: текст → аудио или аудио → текст.'
                    : chatStore.mode === 'video'
                      ? 'Опишите ролик, выберите модель и запустите генерацию видео.'
                      : chatStore.mode === 'image'
                        ? 'Опишите изображение, выберите модель и при необходимости прикрепите референс.'
                        : 'Начните новый диалог, выберите модель и при необходимости прикрепите файлы или изображения.'}
            </p>
        </div>
    );
});

export default EmptyState;
